<template>
  <div id="app">
    <a href="#main-content" class="skip-link" @click="skipToMain">Skip to main content</a>
    <Header v-if="showSiteChrome"></Header>
    <main id="main-content" role="main" tabindex="-1">
      <router-view/>
    </main>
    <Footer v-if="showSiteChrome"></Footer>
    <notifications group="allAlerts" position="top center" />
    <div
      id="screen-reader-announcer"
      class="sr-only"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    ></div>
    <div
      id="screen-reader-announcer-assertive"
      class="sr-only"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    ></div>
  </div>
</template>

<script>
import Header from "@/components/header";
import Footer from "@/components/newfooter";

const CHROMELESS_ROUTES = ['login', 'register', 'forgotpassword', 'marketsmithindia', 'psiverify'];

export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  computed: {
    showSiteChrome () {
      return CHROMELESS_ROUTES.indexOf(this.$route.name) === -1;
    }
  },
  methods: {
    skipToMain (event) {
      event.preventDefault();
      const main = document.getElementById('main-content');
      if (!main) {
        return;
      }
      main.focus({ preventScroll: false });
      main.scrollIntoView();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue